module.exports = __webpack_public_path__ + "img/home-folioBU.dab9e86.jpg";